import {useSyncedRef} from "../../../../misc/SyncedRef";
import {useAsyncAction} from "nate-react-api-helpers";
import {api} from "../../../../api/API";
import {useState} from "react";
import {DialogContent, DialogTitle, Grid, TextField} from "@mui/material";
import {Dialog2} from "../../../../misc/Dialog2";
import {SmoothActionBar} from "../../../../misc/SmoothActionBar";
import {autoFormat} from "./AutoFormat";
import {AltAddress} from "../../../../api/Projects";

export function ManageAlternativeAddress(props: {
    value?: AltAddress
    project?: number;
    onDone(value: AltAddress|undefined): void;
}) {
    const onDoneRef = useSyncedRef(props.onDone);
    const update = useAsyncAction(async input => {
        const addr =await api.projects.upsertAltAddress(input)
        onDoneRef.current(addr);
    }, [])

    const [street, setStreet] = useState(props.value?.addressStreet || "");
    const [city, setCity] = useState(props.value?.addressCity || "");
    const [province, setProvince] = useState(props.value?.addressProvince || "");
    const [postal, setPostal] = useState(props.value?.addressPostal || "");
    const [label, setLabel] = useState(props.value?.name || "");

    const submit = () => {
        update.callback(Object.assign({}, props.value, {
            name: label,
            addressStreet: street,
            addressCity: city,
            addressProvince: province,
            addressPostal: postal,
            project: props.project,
        }));
    };

    return (
        <Dialog2 open onClose={() => props.onDone(undefined)} onEnterPress={submit}>
            <DialogTitle>Alternative Project Address</DialogTitle>
            <DialogContent>
                <div style={{height: 8}} />
                <Grid container spacing={2} direction="column">
                    <Grid item><TextField fullWidth label="Label" value={label} onChange={e => setLabel(e.target.value)} /></Grid>
                    <Grid item><TextField fullWidth label="Street Address" value={street} onChange={e => setStreet(e.target.value)} /></Grid>
                    <Grid item>
                        <Grid container spacing={1}>
                            <Grid item>
                                <TextField label="City" value={city} onChange={e => setCity(e.target.value)} />
                            </Grid>
                            <Grid item>
                                <TextField style={{width: 80}} label="Province" value={province} onChange={e => setProvince(e.target.value)} />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item>
                        <TextField
                            style={{width: 100}} label="Postal"
                            value={postal} onChange={e => setPostal(autoFormat(e.target.value, "postal"))}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <SmoothActionBar
                loading={update.loading}
                destroyLoading={update.loading}
                error={update.error}
                onSubmit={submit}
                onCancel={() => props.onDone(undefined)}
                onDestroy={props.value ? () => {
                    update.callback(Object.assign({}, props.value, {
                        archived: true,
                    }));
                } : undefined}
                destroyName="Archive"
            />
        </Dialog2>
    )
}